$(function () {
  'use strict';
  
  //////////////////////////////////////////////////////////////////////////////////////
  //
  // V A R I A B L E S
  //
  //////////////////////////////////////////////////////////////////////////////////////

  var $fn = {},
    $el = {
      window       : $(window),
      html         : $('html'),
      body         : $('body'),
      document     : $('.l-document'),
      recruitSlide : ''
    },
    param = {
        winW        : window.innerWidth || $el.window.width(),
        winH        : window.innerHeight || $el.window.height(),
        docW        : $el.document.outerWidth(),
        docH        : $el.document.outerHeight(),
    };




  //////////////////////////////////////////////////////////////////////////////////////
  //
  // C O M M O N
  //
  //////////////////////////////////////////////////////////////////////////////////////
    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {

    }


    /* ************************************************
      * link
      *
      * リンク
      *
     ************************************************* */



    /* ************************************************
      * smoothScroll
      *
      * スムーススクロール
      *
     ************************************************* */
    $fn.smoothScroll = function () {
        $('body').on('click', 'a[href^="#"]', function () {
            var header_h = $('.l-header').innerHeight();
            var href= $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top-header_h;
            $('body,html').animate({scrollTop:position}, 1200, 'easeOutQuart');
            return false;
        });
    }
    /* ************************************************
      * naviToggle
      *
      * ナビトグル
      *
     ************************************************* */
    $fn.navigationClick = function(){

        $(document).on('click touchend',function(e) {
            if($(e.target).closest('.nav-bg').length){
                $('.p-main-nav').removeClass('is-active');
                $('.toggle').removeClass('is-active');
            }
        });
        $('.toggle').on('click',function () {
            if($('.p-main-nav').hasClass('is-active') === false){
                $('.p-main-nav').addClass('is-active');
                $('.toggle').addClass('is-active');
            }else{
                $('.p-main-nav').removeClass('is-active');
                $('.toggle').removeClass('is-active');
            }
        });


    };


    $fn.navigationClick();

    /* ************************************************
      * langToggle
      *
      * 言語スイッチ
      *
     ************************************************* */
    $fn.langToggle = function(){

        $('.bogo-language-switcher li.current').on('click',function (e) {
            e.preventDefault();

            if($('.bogo-language-switcher li').hasClass('is-active') === false){
                $('.bogo-language-switcher li').each(function () {
                    if($(this).hasClass('current') === false){
                        $(this).addClass('is-active')
                    }
                });
            }else{
                $('.bogo-language-switcher li').removeClass('is-active');
            }
        });


    };


    $fn.langToggle();
    /* ************************************************
   * scrollNavi
   *
   * スクロールでナビトグル
   *
  ************************************************* */

  //////////////////////////////////////////////////////////////////////////////////////
  //
  // E V E N T
  //
  //////////////////////////////////////////////////////////////////////////////////////


    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var $target_parent = $('.about-image');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();
        var mainW = $target_parent.width();


        $target.css({
            height:mainImgW*ratio+'px'
        })

    };





  // objectFitImages('img.object-fit-img');
  $fn.smoothScroll();
  //$fn.linePos();



  /* resize
  ============================================================== */
  $el.window.resize('load', function () {
      $fn.mainimgSize();
  });





  /* weater
  ============================================================== */

    $.ajax({
        url: '//api.openweathermap.org/data/2.5/weather?id=1850892&appid=f40c158cb90ab7bbe667dec4aef14a9d&units=metric',
        dataType: 'json',
        data: {name: 'chara'},
        success: function(data){
            var temp = Math.floor(data.main.temp);
            temp = temp+'&#176;';

            var weather = data.weather[0].main;
            var weather_desc = data.weather[0].description;

            switch (weather) {
                case "Clear":
                    $('.weather-box .temp').addClass('clear');
                    break;
                case "Clouds":
                    $('.weather-box .temp').addClass('clouds');
                    if(weather_desc == 'few clouds'){
                        $('.weather-box .temp').removeClass('clouds');
                        $('.weather-box .temp').addClass('clear');
                    }
                    break;
                case "Rain":
                    $('.weather-box .temp').addClass('rain');
                    break;
                case "Thunderstorm":
                    $('.weather-box .temp').addClass('rain');
                    break;
                case "Drizzle":
                    $('.weather-box .temp').addClass('rain');
                    break;
                case "Snow":
                    $('.weather-box .temp').addClass('snow');
                    break;
                case "Mist":
                    $('.weather-box .temp').addClass('clouds');
                    break;
            }

            $('.weather-box .temp span').html(temp);

        }
    });

});



// common
$(window).on("load",function(){

    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $('.l-document'),
            recruitSlide : ''
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            filter_index: ''

        };
    // var anim = TweenMax.to(".page-loading figure", 1, {ease: Elastic.easeOut.config(1, 1), scale: 1,
    //     onComplete:function () {
    //         $fn.loadedAnimation();
    //     }
    // });
    //
    // $fn.loadedAnimation  = function(){
    //     var anim = TweenMax.to(".page-loading figure", .5, {ease: Elastic.easeOut.config(1, 1), scale:0,opacity:0,delay:.3});
    //     var anim = TweenMax.to(".page-loading .bg", .5, {ease: Expo.easeOut, top: '-100%',delay:.8,
    //         onComplete:function () {
    //             $('.page-loading').addClass('loaded');
    //
    //         }
    //     });
    //
    // };

    $fn.mainimgSize = function () {
        var $target = $('.main-carousel');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();

        $target.css({
            height:mainImgW*ratio+'px'
        })

    };

    $fn.mainimgSize2 = function () {
        var $target = $('.main-carousel2');
        var ratio = 0.65;

        var mainImgW = $('.carousel-cell img').width();
        var mainImgH = $('.carousel-cell img').height();


        $target.css({
            height:mainImgW*ratio+'px'
        })

    };

    $fn.scrollNavi = function (scroll_amount) {
        var openFlag = false;
        $('.hidden-menu .category-box').each(function () {
            if($(this).attr('class').indexOf('open') !== -1){
                openFlag = true;
            }
        });
        if(scroll_amount > 100 && !openFlag){
            $('.l-header').addClass('scroll');
        }else if(scroll_amount <= 100 && !openFlag){
            $('.l-header').removeClass('scroll');
        }
    };





    $(document).on("click", ".hidden-menu", function( e ) {
        e.stopPropagation();
    } );



    $fn.indexSlider = function() {
        if ($('.l-section-index-carousel').length) {

            var options = {
                cellSelector: '.carousel-cell',
                cellAlign : 'center',
                pageDots : false,
                prevNextButtons : false,
                accessibility : false,
                wrapAround : true,
                imagesLoaded : true,
                pauseAutoPlayOnHover: true,
                fullscreen: true,
                lazyLoad: 1,
                draggable:true
            };
            var time = 5;
            var $bar,
                $slider,
                isPause,
                tick,
                percentTime;

            $('.l-section-index-carousel').flickity(options);

            $slider = $('.l-section-index-carousel');
            var flkty = $slider.data('flickity');
            var selectedIndex = flkty.selectedIndex;

            var slideCount = flkty.slides.length;
            var $pagers = $('.carousel__page-dots');

            for (i = 0; i < slideCount; i++) {
                $pagers.append('<li class="gallery__page-dot-item"></li>');
            }

            var $pager = $pagers.find('li');

            var $caption = $('.gallery__caption .image-caption');

            $slider.on( 'select.flickity', function() {
                // set image caption using img's alt
                $caption.text( flkty.selectedElement.children[0].alt );
                $pager.filter('.is-selected').removeClass('is-selected');
                $pager.eq(flkty.selectedIndex).addClass('is-selected');
            });

            $pagers.on( 'click', 'li', function() {
                var index = $(this).index();
                resetProgressbar();
                $slider.flickity( 'select', index );
                startProgressbar();
            });

            $slider.on( 'change.flickity', function( event, index ) {
                resetProgressbar();
                $slider.flickity( 'select', index );
                startProgressbar();
            });

            $slider.on( 'dragStart.flickity', function( event, pointer ) {
                isPause = true;
            });
            $slider.on( 'dragEnd.flickity', function( event, pointer ) {
                isPause = false;

            });


            // // previous
            // var $prev = $container.find('.prev');
            // $prev.on( 'click', function() {
            //     resetProgressbar();
            //     $slider.flickity('previous');
            //     startProgressbar();
            // });
            // // next
            // var $next = $container.find('.next');
            // $next.on( 'click', function() {
            //     resetProgressbar();
            //     $slider.flickity('next');
            //     startProgressbar();
            // });

            $bar = $('.carousel__progress .progress');

            $slider.on({
                mouseenter: function() {
                    isPause = true;
                },
                mouseleave: function() {
                    isPause = false;
                }
            })

            function startProgressbar() {
                resetProgressbar();
                percentTime = 0;
                isPause = false;
                tick = setInterval(interval, 12);
            }

            function interval() {
                if(isPause === false) {
                    percentTime += 1 / (time+0.1);
                    $bar.css({
                        width: percentTime+"%"
                    });
                    if(percentTime >= 100)
                    {
                        $slider.flickity('next', true);
                        startProgressbar();
                    }
                }
            }


            function resetProgressbar() {
                $bar.css({
                    width: 0+'%'
                });
                clearTimeout(tick);
            }

            startProgressbar();
            // var carousel = document.querySelector('.l-section-index-carousel');
            // param.flkty = new Flickity(carousel, {
            //     imagesLoaded: true,
            //     percentPosition: false,
            //     autoPlay: true,
            //     friction: .4,
            //     contain: true,
            //     prevNextButtons : false,
            //     pageDots: false,
            //     wrapAround: true,
            //     pauseAutoPlayOnHover: false,
            //     initialIndex: Math.floor( Math.random() * carousel.children.length )
            // });
            //
            // param.flkty.on('select', function () {
            // });
            // // param.flkty.stopPlayer();
            // var imgs = carousel.querySelectorAll('.carousel-cell img');
            // var docStyle = document.documentElement.style;
            // var transformProp = typeof docStyle.transform == 'string' ?
            //     'transform' : 'WebkitTransform';
            //
            // param.flkty.on('scroll', function () {
            //     param.flkty.slides.forEach(function (slide, i) {
            //         var img = imgs[i],
            //             x = 0;
            //
            //         if (0 === i) {
            //             x = Math.abs(param.flkty.x) > param.flkty.slidesWidth ? ( param.flkty.slidesWidth + param.flkty.x + param.flkty.slides[param.flkty.slides.length - 1].outerWidth + slide.target ) : ( slide.target + param.flkty.x );
            //         } else if (i === param.flkty.slides.length - 1) {
            //             x = Math.abs(param.flkty.x) + param.flkty.slides[i].outerWidth < param.flkty.slidesWidth ? ( slide.target - param.flkty.slidesWidth + param.flkty.x - param.flkty.slides[i].outerWidth ) : ( slide.target + param.flkty.x );
            //         } else {
            //             x = slide.target + param.flkty.x;
            //         }
            //
            //         img.style[transformProp] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
            //         img.style.position = 'absolute';
            //         img.style.left = param.leftPos + 'px';
            //     });
            // });
            //
            // param.flkty.on( 'settle', function() {
            //     param.flkty.playPlayer();
            // });



        }

    };




    $fn.indexSlider();

    // param.scrollpos = amount;
    //
    // // $fn.scrollparallax();
    // var amount = $(this).scrollTop();
    // $fn.scrollNavi(amount);
    // clearTimeout( param.timer );
    // param.timer = setTimeout(function() {
    //     param.scrollpos = amount;
    // }, 10 );


});

window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload();
    }
};